module.exports = __webpack_public_path__ + "static/login_cover.eb9a7fce.png";